"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _warning = _interopRequireDefault(require("rc-util/lib/warning"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(valid, component, message) {
  (0, _warning.default)(valid, "[antd-compatible: ".concat(component, "] ").concat(message));
};

exports.default = _default;